import React from 'react'
import { Link } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { Box, Divider, Typography } from '@mui/material'
import { formatNumber } from '../../../packages/utils/numberFormatters'
import { FactsTable, FactsTableRow } from '../../components/FactsTable'
import { ConvertibleEntity } from 'types/ConvertibleEntity'

interface CompensationLendersProps {
    convertible: ConvertibleEntity
}

export const CompensationLenders = ({ convertible }: CompensationLendersProps) => {
    const { i18n } = useTranslation()
    const locale = i18n.language

    const warrants = convertible.warrants

    const rows: { key: string; label: string | React.ReactNode }[] = [
        ...warrants
            .map((warrant) => ({
                originIssue: warrant.origins.find((origin) => origin.convertibleId === convertible.id),
                warrant,
            }))
            .filter(({ originIssue }) => !!originIssue)
            .map(({ originIssue, warrant }) => ({
                key: warrant.id,
                label: (
                    <>
                        <span>
                            {formatNumber(originIssue?.numberOfWarrants ?? 0, {
                                locale,
                                decimals: 0,
                            })}{' '}
                        </span>
                        <Link to={`/warrants/${warrant.id}`}>{warrant.instrumentName || warrant.name}</Link>
                    </>
                ),
            })),
    ]

    return (
        <Box
            sx={{
                mb: 4,
            }}
        >
            <Typography variant='subtitle2'>Långivare erhöll teckningsoptioner</Typography>
            <FactsTable>
                {rows.map(({ key, label }, index) => (
                    <FactsTableRow
                        key={key}
                        label={label}
                        hasDivider={false}
                        hasBottomPadding={index === rows.length - 1}
                    />
                ))}
            </FactsTable>
            <Divider />
        </Box>
    )
}
